import CryptoJS from 'crypto-js';
import { jwtDecode } from 'jwt-decode';
import Strings from '../constants/stringConstant';
import Path from '../constants/path';
import makeApiCall from '../api/makeApiCall';
import { leadDropdown, loanPurpose } from '../api/request/leadApi/leadApi';
import { logoutApi, roleData } from '../api/request/loginApi/loginApi';
import { resetPayLoadValue } from '../state/slice/leadListPayloadSlice';
import { clearLeadValue } from '../state/slice/leadSlice';
import { resetMccValue } from '../state/slice/mccListSlice';
import { resetPlatformPayLoadValue } from '../state/slice/platformListPayloadSlice';
import { resetAllLocValues } from '../state/slice/locationSlice';
import { resetFilterValue } from '../state/slice/filterSlice';
import { logout } from '../state/slice/userSlice';
import { toast } from 'react-toastify';
import { format, parse } from 'date-fns';
import { setRbacValue } from '../state/slice/rbacSlice';
import { useSelector } from 'react-redux';

class AESUtils {
  constructor() {
    this.ivLength = 16;
    this.algorithm = 'AES-256-CBC';
    this.secretKey = CryptoJS.lib.WordArray.random(32);
    this.iv = CryptoJS.lib.WordArray.random(this.ivLength);
  }

  encrypt(dataToEncrypt) {
    const cipher = CryptoJS.AES.encrypt(dataToEncrypt, this.secretKey, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return `${this.iv.toString(CryptoJS.enc.Hex)}:${cipher.toString()}`;
  }

  decrypt(encryptedData) {
    const [ivHex, encryptedText] = encryptedData.split(':');
    const iv = CryptoJS.enc.Hex.parse(ivHex);

    const decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(encryptedText),
      },
      this.secretKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );

    return decrypted.toString(CryptoJS.enc.Utf8).trim();
  }
}

const generateHashKey = key => {
  return CryptoJS.SHA256(key).toString(CryptoJS.enc.Hex);
};

const base64Encrypt = dataToEncrypt => {
  const ciphertext = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(dataToEncrypt),
  );

  return ciphertext;
};

const base64Decrypt = encryptedData => {
  const bytes = CryptoJS.enc.Base64.parse(encryptedData);

  return bytes.toString(CryptoJS.enc.Utf8).trim();
};

export { AESUtils, generateHashKey, base64Encrypt, base64Decrypt };

export const getUserData = () => {
  const token = sessionStorage.getItem(Strings?.login?.auth_token);
  const accessToken = token && JSON.parse(token).accessToken;
  // Check if accessToken exists and is a string
  if (accessToken && typeof accessToken === 'string') {
    try {
      const decodedValue = jwtDecode(accessToken);

      return decodedValue;
    } catch (error) {
      console.error('Error decoding JWT', error);
    }
  } else {
    console.warn('No access token found or token is not a string');
  }

  return null;
};
export const base64ToDataURL = (base64String, mimeType) => {
  return `data:${mimeType};base64,${base64String}`;
};

export const maskAadhaarNumber = aadhaarNumber => {
  // if (typeof aadhaarNumber !== 'string' || aadhaarNumber.length !== 12) {
  //   throw new Error('Invalid Aadhaar number. Must be a 12-digit string.');
  // }

  // Masking all except the last 4 digits
  const maskedAadhaar =
    aadhaarNumber && `XXXXXXXX${aadhaarNumber?.substring(8)}`;

  return maskedAadhaar;
};
export const maskBankAccountNumber = accountNumber => {
  // returning just the last 4 digits
  const maskedAccountNo = accountNumber && `XXXX ${accountNumber?.slice(-4)}`;

  return maskedAccountNo;
};

export const calculateAge = dob => {
  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

export const fetchDashboardType = applicationType => {
  let dashboardType = '';

  switch (applicationType) {
    case Strings.loan_applications.application_type_rejected:
      dashboardType = Strings.loan_applications.dashBoard_type_rejected;
      break;

    case Strings.loan_applications.application_type_qde:
      dashboardType = Strings.loan_applications.qde;
      break;

    case Strings.loan_applications.application_type_dde:
      dashboardType = Strings.loan_applications.dde;
      break;
    case Strings.loan_applications.application_type_fi:
      dashboardType = Strings.loan_applications.dashboard_type_fi;

      break;
    case Strings.loan_applications.application_type_review_fi:
      dashboardType = Strings.loan_applications.dashboard_type_review_fi;
      break;
    case Strings.loan_applications.application_type_review_cd:
      dashboardType = Strings.loan_applications.dashboard_type_review_cd;

      break;
    case Strings.loan_applications.application_type_personal_dis:
      dashboardType = Strings.loan_applications.dashboard_type_personal_dis;

      break;
    case Strings.loan_applications.application_type_onhold:
      dashboardType = Strings.loan_applications.dashboard_type_onhold;

      break;
    case Strings.loan_applications.application_type_eligibility:
      dashboardType = Strings.loan_applications.dashboard_type_eligiblity;

      break;
    case Strings.loan_applications.application_type_con_dis:
      dashboardType = Strings.loan_applications.dashboard_type_con;

      break;
    case Strings.loan_applications.application_type_order_con:
      dashboardType = Strings.loan_applications.dashboard_type_order_con;

      break;
    case Strings.loan_applications.application_type_approval_flow:
      dashboardType = Strings.loan_applications.dashboard_type_approval_flow;

      break;
    case Strings.loan_applications.application_type_loan_booking:
      dashboardType = Strings.loan_applications.dashboard_type_loan_booking;

      break;
    case Strings.loan_applications.application_type_doc_esign:
      dashboardType = Strings.loan_applications.dashboard_type_doc_esign;

      break;
    case Strings.loan_applications.application_type_doc_verify:
      dashboardType = Strings.loan_applications.dashboard_type_doc_verify;

      break;
    case Strings.loan_applications.application_type_part_approval:
      dashboardType = Strings.loan_applications.dashboard_type_part_approval;

      break;
    case Strings.loan_applications.application_type_partner_app:
      dashboardType = Strings.loan_applications.dashboard_type_partner_app;

      break;
    case Strings.loan_applications.application_type_disbursement:
      dashboardType = Strings.loan_applications.dashboard_type_disbursement;

      break;
    case Strings.manageReassignement.manageReassignementHeader:
      dashboardType = Strings.manageReassignement.manageReassignementHeader;

      break;
    case Strings.loan_applications.dashboard_type_fcu:
      dashboardType = Strings.loan_applications.dashboard_type_fcu;

      break;
    case Strings.loan_applications.dashboard_type_sr:
      dashboardType = Strings.loan_applications.dashboard_type_sr;

      break;
    case Strings.loan_applications.dashboard_type_legal_review:
      dashboardType = Strings.loan_applications.dashboard_type_legal_review;

      break;
    case Strings.loan_applications.dashboard_type_property_valuer:
      dashboardType = Strings.loan_applications.dashboard_type_property_valuer;

      break;
    case Strings.loan_applications.dashboard_type_sanction:
      dashboardType = Strings.loan_applications.dashboard_type_sanction;

      break;
    case Strings.loan_applications.dashboard_type_deviation_appro:
      dashboardType = Strings.loan_applications.dashboard_type_deviation_appro;

      break;
    case Strings.loan_applications.app_type_tranche_dis:
      dashboardType = Strings.loan_applications.dash_type_tranche_dis;

      break;
    case Strings.loan_applications.app_type_tranche_ver:
      dashboardType = Strings.loan_applications.dash_type_tranche_ver;

      break;
    case Strings.loan_applications.app_type_tranche_exe:
      dashboardType = Strings.loan_applications.dash_type_tranche_exe;
      break;
    case Strings.loan_applications.dashboard_type_co_lending:
      dashboardType = Strings.loan_applications.dashboard_type_co_lending;

      break;
    case Strings.loan_applications.dash_type_pending_partner_upd:
      dashboardType =
        Strings.loan_applications.dash_type_pending_partner_upd;

      break;
    default:
      // Optional: handle any other cases or leave as is
      break;
  }

  return dashboardType; // Return the dashboard value
};

export const fetchDynamicBreadCrumbPath = applicationType => {
  let dynamicPath = { name: Strings.loan_applications.dde, link: Path.loan_dde };

  switch (applicationType) {
    case Strings.loan_applications.application_type_rejected:
      dynamicPath = {
        name: Strings.loan_applications.dashBoard_type_rejected,
        link: Path.loan_application_reject,
      };
      break;

    case Strings.loan_applications.application_type_qde:
      dynamicPath = {
        name: Strings.loan_applications.qde,
        link: Path.loan_qde,
      };
      break;

    case Strings.loan_applications.application_type_dde:
      dynamicPath = { name: Strings.loan_applications.dde, link: Path.loan_dde };
      break;
    case Strings.loan_applications.application_type_fi:
      dynamicPath = {
        name: Strings.loan_applications.application_type_fi,
        link: Path.loan_fi,
      };
      break;

    case Strings.loan_applications.application_type_review_fi:
      dynamicPath = {
        name: Strings.loan_applications.application_type_review_fi,
        link: Path.loan_review_fi,
      };
      break;
    case Strings.loan_applications.application_type_review_cd:
      dynamicPath = {
        name: Strings.loan_applications.application_type_review_cd,
        link: Path.loan_review_fi,
      };
      break;
    case Strings.loan_applications.application_type_personal_dis:
      dynamicPath = {
        name: Strings.loan_applications.application_type_personal_dis,
        link: Path.loan_personal_discussion,
      };
      break;
    case Strings.loan_applications.dashboard_type_fcu:
      dynamicPath = {
        name: Strings.loan_applications.dashboard_type_fcu,
        link: Path.loan_fcu,
      };
      break;
    case Strings.loan_applications.dashboard_type_sr:
      dynamicPath = {
        name: Strings.loan_applications.dashboard_type_sr,
        link: Path.loan_sr,
      };
      break;
    case Strings.loan_applications.dashboard_type_legal_review:
      dynamicPath = {
        name: Strings.loan_applications.dashboard_type_legal_review,
        link: Path.loan_legal_review,
      };
      break;
    case Strings.loan_applications.dashboard_type_property_valuer:
      dynamicPath = {
        name: Strings.loan_applications.dashboard_type_property_valuer,
        link: Path.loan_property_valuer,
      };
      break;
    case Strings.loan_applications.dashboard_type_sanction:
      dynamicPath = {
        name: Strings.loan_applications.dashboard_type_sanction,
        link: Path.loan_sanction,
      };
      break;
    case Strings.loan_applications.dashboard_type_deviation_appro:
      dynamicPath = {
        name: Strings.loan_applications.dashboard_type_deviation_appro,
        link: Path.loan_deviation_approval,
      };
      break;
    case Strings.loan_applications.dashboard_type_co_lending:
      dynamicPath = {
        name: Strings.loan_applications.dashboard_type_co_lending,
        link: Path.loan_co_lending,
      };
      break;
    case Strings.loan_applications.dashboard_type_partner_app:
      dynamicPath = {
        name: Strings.loan_applications.dashboard_type_partner_app,
        link: Path.loan_partner_approval,
      };
      break;
    case Strings.loan_applications.dash_type_pending_partner_upd:
      dynamicPath = {
        name: Strings.loan_applications.dash_type_pending_partner_upd,
        link: Path.loan_pending_partner_update,
      };
      break;
    case Strings.loan_applications.application_type_onhold:
      dynamicPath = {
        name: Strings.loan_applications.application_type_onhold,
        link: Path.loan_onhold,
      };
      break;

    case Strings.loan_applications.application_type_con_dis:
      dynamicPath = {
        name: Strings.loan_applications.application_type_con_dis,
        link: Path.loan_conversation,
      };
      break;

    case Strings.loan_applications.application_type_order_con:
      dynamicPath = {
        name: Strings.loan_applications.application_type_order_con,
        link: Path.loan_order_con,
      };
      break;

    case Strings.loan_applications.application_type_eligibility:
      dynamicPath = {
        name: Strings.loan_applications.application_type_eligibility,
        link: Path.loan_eligibility,
      };
      break;
    case Strings.loan_applications.application_type_approval_flow:
      dynamicPath = {
        name: Strings.loan_applications.application_type_approval_flow,
        link: Path.loan_approval_flow,
      };
      break;
    case Strings.loan_applications.application_type_loan_booking:
      dynamicPath = {
        name: Strings.loan_applications.application_type_loan_booking,
        link: Path.loan_loan_booking,
      };
      break;
    case Strings.loan_applications.application_type_doc_esign:
      dynamicPath = {
        name: Strings.loan_applications.application_type_doc_esign,
        link: Path.loan_document_esign,
      };
      break;
    case Strings.loan_applications.application_type_doc_verify:
      dynamicPath = {
        name: Strings.loan_applications.application_type_doc_verify,
        link: Path.loan_document_verify,
      };
      break;
    case Strings.loan_applications.application_type_disbursement:
      dynamicPath = {
        name: Strings.loan_applications.application_type_disbursement,
        link: Path.loan_disbursement,
      };
      break;
    case Strings.loan_applications.app_type_tranche_dis:
      dynamicPath = {
        name: Strings.loan_applications.app_type_tranche_dis,
        link: Path.loan_tranche_disbursement,
      };
      break;
    case Strings.loan_applications.app_type_tranche_ver:
      dynamicPath = {
        name: Strings.loan_applications.app_type_tranche_ver,
        link: Path.loan_tranche_verification,
      };
      break;
    case Strings.loan_applications.app_type_tranche_exe:
      dynamicPath = {
        name: Strings.loan_applications.app_type_tranche_exe,
        link: Path.loan_tranche_execution,
      };
      break;
    case Strings.loanSearch.loanSearch:
      dynamicPath = {
        name: Strings.loanSearch.loanSearchDetail,
        link: Path.loan_search_detail,
      };
      break;

    case Strings.loan_applications.application_type_partner_app:
      dynamicPath = {
        name: Strings.loan_applications.application_type_partner_app,
        link: Path.loan_partner_approval,
      };
      break;
    case Strings.loan_applications.application_type_co_lending:
      dynamicPath = {
        name: Strings.loan_applications.application_type_co_lending,
        link: Path.loan_co_lending,
      };
      break;

    default:
      dynamicPath = {
        name: applicationType,
        link: '/',
      };
      break;
  }

  return dynamicPath; // Return the dynamic path
};

export const fetchDynamicOptions = async payloadPassed => {
  try {
    const payload = payloadPassed;
    const response = await makeApiCall(leadDropdown(payload));
    if (response.data.status === Strings.success) {
      const responseValue = response?.data?.data;

      return responseValue;
    } else {
      toast.error(Strings.apiError);

      return;
    }
  } catch (error) {
    console.log('An error occurred at Cattle-component', error);
    toast.error(Strings.apiError);
  }
};
export const fetchDynamicBreedOptions = async payloadPassed => {
  try {
    const payload = payloadPassed;
    const response = await makeApiCall(loanPurpose(payload));
    if (response.data.status === Strings.success) {
      const responseValue = response?.data?.data;

      return responseValue;
    } else {
      toast.error(Strings.apiError);

      return;
    }
  } catch (error) {
    console.log('An error occurred at Cattle-component', error);
    toast.error(Strings.apiError);
  }
};

export const hasEditValue = obj => {
  const checkEdit = nestedObj => {
    for (const key in nestedObj) {
      if (typeof nestedObj[key] === 'object') {
        if (checkEdit(nestedObj[key])) {
          return true;
        }
      } else if (nestedObj[key] === 'edit') {
        return true;
      }
    }

    return false;
  };

  return checkEdit(obj);
};

export const hasRbacTabOrSectionPermission = (
  rbacStore,
  stage,
  tabName,
  section,
) => {
  try {
    if (section === null) {
      return (
        Object.keys(rbacStore?.[stage]?.tabs[tabName] || {}).length > 0 ||
        ['history', 'validation_summary'].includes(tabName)
      );
    }

    return (
      rbacStore?.[stage]?.tabs[tabName]?.sections?.[section] !== undefined ||
      false
    );
  } catch (error) {
    console.error('An error occurred:', error);

    return false;
  }
};

export const hasEditPermission = (rbacStore, stage, tabName, section) => {
  try {
    return rbacStore?.[stage]?.tabs[tabName]?.sections?.[section] === 'edit';
  } catch (error) {
    console.error('An error occurred:', error);

    return false;
  }
};

export const determineProceedStage = applicationType => {
  const { productId } = useSelector(state => state.productFilterSlice);
  const { partnerDetails } = useSelector(state => state.loanSearchProduct);
  const userData = getUserData();
  switch (applicationType) {
    case 'QDE':
      return {
        fromStage: 'QDE',
        toStage: 'DDE',
        fromSuccess: 'QDE',
        toSuccess: 'DDE',
      };
    case 'DDE':
      if (productId === 1 || productId === 3) {
        return {
          fromStage: 'DDE',
          toStage: 'Field Investigation',
          fromSuccess: 'DDE',
          toSuccess: 'Field Investigation',
        };
      } else {
        return {
          fromStage: 'DDE',
          toStage: 'Review BM',
          fromSuccess: 'DDE',
          toSuccess: 'Review BM',
        };
      }
    case 'Field Investigation':
      return {
        fromStage: 'Field Investigation',
        toStage: 'Review & FI',
        fromSuccess: 'Field Investigation',
        toSuccess: 'Personal Discussion',
      };
    case 'Review & FI':
      return {
        fromStage: 'Review & FI',
        toStage: 'Personal Discussion',
        fromSuccess: 'Field Investigation',
        toSuccess: 'Personal Discussion',
      };
    case 'Review':
      if (productId === 3) {
        return {
          fromStage: 'Review',
          toStage: 'Personal Discussion',
          fromSuccess: 'Review',
          toSuccess: 'Personal Discussion',
        };
      } else if (userData?.role === 'RL002') {
        return {
          fromStage: 'Review BM',
          toStage: 'Review CO',
          fromSuccess: 'Review BM',
          toSuccess: 'Review CO',
        };
      } else {
        return {
          fromStage: 'Review CO',
          toStage: 'Eligibility Check & CAM',
          fromSuccess: 'Review CO',
          toSuccess: 'Eligibility Check & CAM',
        };
      }
    case 'Personal Discussion':
      return {
        fromStage: 'Personal Discussion',
        toStage: 'Eligibility Check & CAM',
        fromSuccess: 'Personal Discussion',
        toSuccess: 'Eligibility Check & CAM',
      };
    case Strings.loan_applications.application_type_eligibility:
      if (productId === 1) {
        return {
          fromStage: 'Eligibility Check & CAM',
          toStage: 'Approval Workflow',
          fromSuccess: 'Eligibility Check & CAM',
          toSuccess: 'Approval Workflow',
        };
      } else {
        return {
          fromStage: 'Eligibility Check & CAM',
          toStage: 'Loan Booking',
          fromSuccess: 'Eligibility Check & CAM',
          toSuccess: 'Loan Booking',
        };
      }
    case Strings.loan_applications.application_type_approval_flow:
      return {
        fromStage: 'Approval Workflow',
        toStage: 'Loan Booking',
        fromSuccess: 'Approval Workflow',
        toSuccess: 'Loan Booking',
      };
    case Strings.loan_applications.application_type_loan_booking:
      return {
        fromStage: 'Loan Booking',
        toStage: 'Document Execution & E-sign',
        fromSuccess: 'Loan Booking',
        toSuccess: 'Document Execution & E-sign',
      };
    case Strings.loan_applications.application_type_doc_esign:
      return {
        fromStage: 'Document Execution & E-sign',
        toStage: 'Document Verification',
        fromSuccess: 'Document Execution & E-sign',
        toSuccess: 'Document Verification',
      };
    case Strings.loan_applications.application_type_doc_verify:
      if (productId === 1 || productId === 3) {
        return {
          fromStage: 'Document Verification',
          toStage: partnerDetails?.partnerCode === 'CL003' ? 'Pending Partner Updates' : 'Disbursement',
          fromSuccess: 'Document Verification',
          toSuccess: partnerDetails?.partnerCode === 'CL003' ? 'Pending Partner Updates' : 'Disbursement',
        };
      } else {
        return {
          fromStage: 'Document Verification',
          toStage: 'Order Confirmation',
          fromSuccess: 'Document Verification',
          toSuccess: 'Order Confirmation',
        };
      }
    case Strings.loan_applications.application_type_order_con:
      return {
        fromStage: 'Order Confirmation',
        toStage: 'Disbursement',
        fromSuccess: 'Order Confirmation',
        toSuccess: 'Disbursement',
      };
    case Strings.loan_applications.application_type_disbursement:
      return {
        fromStage: 'Disbursement',
        toStage: 'Disbursement',
        fromSuccess: 'Disbursement',
        toSuccess: 'Disbursement',
      };
    case Strings.loan_applications.dashboard_type_sr:
      return {
        fromStage: 'Secondary Review',
        toStage: 'Approval Workflow',
        fromSuccess: 'Secondary Review',
        toSuccess: 'Approval Workflow',
      };
    case Strings.loan_applications.dashboard_type_fcu:
      return {
        fromStage: 'Fraud Control Unit',
        toStage: 'Fraud Control Unit',
        fromSuccess: 'Fraud Control Unit',
        toSuccess: 'Fraud Control Unit',
      };
    case Strings.loan_applications.dashboard_type_legal_review:
      return {
        fromStage: 'Legal Review',
        toStage: 'Legal Review',
        fromSuccess: 'Legal Review',
        toSuccess: 'Legal Review',
      };
    case Strings.loan_applications.dashboard_type_property_valuer:
      return {
        fromStage: 'Property Valuation',
        toStage: 'Property Valuation',
        fromSuccess: 'Property Valuation',
        toSuccess: 'Property Valuation',
      };
    case Strings.loan_applications.dashboard_type_deviation_appro:
      return {
        fromStage: 'Deviation Approval',
        toStage: 'Deviation Approval',
        fromSuccess: 'Deviation Approval',
        toSuccess: 'Deviation Approval',
      };
    case Strings.loan_applications.dashboard_type_sanction:
      return {
        fromStage: 'Sanction',
        toStage: 'Sanction',
        fromSuccess: 'Sanction',
        toSuccess: 'Sanction',
      };
    case Strings.loan_applications.app_type_tranche_dis:
      return {
        fromStage: 'Tranche Disbursement',
        toStage: 'Tranche Disbursement',
        fromSuccess: 'Tranche Disbursement',
        toSuccess: 'Tranche Disbursement',
      };
    case Strings.loan_applications.app_type_tranche_ver:
      return {
        fromStage: 'Tranche Verification',
        toStage: 'Tranche Disbursement',
        fromSuccess: 'Tranche Verification',
        toSuccess: 'Tranche Disbursement',
      };
    case Strings.loan_applications.app_type_tranche_exe:
      return {
        fromStage: 'Tranche Execution',
        toStage: 'Tranche Verification',
        fromSuccess: 'Tranche Execution',
        toSuccess: 'Tranche Verification',
      };
    case Strings.loan_applications.application_type_co_lending:
      return {
        fromStage: 'Co-Lending',
        toStage: 'Partner Approval',
        fromSuccess: 'Co-Lending',
        toSuccess: 'Partner Approval',
      };
    case Strings.loan_applications.application_type_partner_app:
      return {
        fromStage: 'Partner Approval',
        toStage: 'Loan Booking',
        fromSuccess: 'Partner Approval',
        toSuccess: 'Loan Booking',
      };
    case Strings.loan_applications.app_type_pending_partner_upd:
      return {
        fromStage: 'Pending Partner Updates',
        toStage: 'Pending Partner Updates',
        fromSuccess: 'Pending Partner Updates',
        toSuccess: 'Pending Partner Updates',
      };

    default:
      return {};
  }
};
export const logoutFunction = async (dispatch, userId, navigate) => {
  const response = await makeApiCall(
    logoutApi({
      userId: userId,
      remarks: Strings?.logout,
    }),
  );
  if (response?.data?.status === Strings?.success) {
    dispatch(resetAllLocValues());
    dispatch(logout());
    sessionStorage.removeItem('isLoggedIn');
    sessionStorage.removeItem('auth_token');
    dispatch(resetPayLoadValue());
    dispatch(clearLeadValue());
    dispatch(resetMccValue());
    dispatch(resetFilterValue());
    dispatch(resetPlatformPayLoadValue());
    setTimeout(() => {
      navigate(Path.login);
    }, 400);
  } else {
    toast.error(response?.data?.error?.errorMessage);
  }
};
const currencyFormatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
});

export const formatCurrency = value =>
  currencyFormatter.format(value).replace('₹', '₹ ');

export const formatNumberWithCommas = value => {
  if (value === null || value === undefined || value === '') return '';
  const [integer, decimal] = value.toString().split('.');
  const formattedInteger = new Intl.NumberFormat('en-IN').format(integer);

  return decimal !== undefined
    ? `${formattedInteger}.${decimal}`
    : formattedInteger;
};

export const formatTimeWithDateFns = dateTimeString => {
  const parsedDate = parse(dateTimeString, 'HH:mm:ss dd MMMM yyyy', new Date());

  return format(parsedDate, 'h:mm a');
};
export const convertDate = inputDate => {
  const parsedDate = parse(inputDate, 'yyyy-MM-dd', new Date());

  return format(parsedDate, 'd MMMM, yyyy');
};

export const getRoleResponsibility = (role, applicationType) => {
  console.log(applicationType, 'applicationType');
  switch (role) {
    case 'RL003':
      return applicationType;
    case 'RL004':
      return applicationType === 'Approval Workflow' ? 'Approval Workflow CCU' : 'Deviation Approval CCU';
    case 'RL005':
      return applicationType === 'Approval Workflow' ? 'Approval Workflow CH' : 'Deviation Approval CH';
    case 'RL106':
      return applicationType === 'Approval Workflow' ? 'Approval Workflow BH' : 'Deviation Approval BH';
    case 'RL107':
      return applicationType === 'Approval Workflow' ? 'Approval Workflow SCM' : 'Deviation Approval SCM';
    case 'RL108':
      return applicationType === 'Approval Workflow' ? 'Approval Workflow ZCM' : 'Deviation Approval ZCM';
    case 'RL104':
      return 'Secondary Review';
    case 'RL109':
      return 'Deviation Approval LH';

    default:
      return 'Role not recognized';
  }
};
export const fetchRoleData = async (dispatch, roleId, productCasbinKey) => {
  try {
    const payload = {
      roleId: roleId,
      domain: 'web',
      product: productCasbinKey,
    };
    const response = await makeApiCall(roleData(payload));
    if (response?.data?.status === Strings.success) {
      const responseValue = JSON.parse(response?.data?.data?.permission);

      dispatch(setRbacValue({ roleBased: responseValue }));
    } else {
      if (response?.data?.status === Strings.error) {
        console.log('failed:');
      }
    }
  } catch (error) {
    toast.error(Strings.apiError, {
      position: 'top-right',
    });
    console.log('failed:', error);
  }
};

export const getInitial = names => names?.charAt(0).toUpperCase();
